<template>
  <form>
    <div class="row">
      <div class="col-md-5">
        <div class="">
          <input
            type="submit"
            style="color: white;"
            value="Delete Product"
            class="btn btn-danger"
            @click="deleteProduct($event)"
          />
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  name: "DeleteProduct",
  data() {
    return {};
  },
  methods: {
    deleteProduct(e) {
      e.preventDefault();
      console.log(this.$route.params.Id);
      this.$confirm({
        title: "Delete Product",
        content: "Are you sure to delete this product?",
        okText: "Delete",
        okType: "danger",
        cancelText: "Cancel",
        onOk: () => {
          this.$store
            .dispatch("manageProducts/removeProduct", {
              productID: this.$route.params.Id,
            })
            .then(() => {
              this.$router.push("/manage-products");
            })
            .catch(() => {
              this.$message.error("Something went wrong");
            });
        },
      });

      // this.$store.dispatch("productAndSuppliers/deleteProduct", {
      //   id: this.$route.params.id,
      // });
    },
  },
};
</script>
<style></style>
